import React from 'react';
import PortalShell from '@/components/portal/PortalShell';
import LoginForm from '@/components/portal/LoginForm';

const InvestorLogin: React.FC = () => {
  return (
    <PortalShell>
      <LoginForm
        title="Investor Sign In"
        subtitle="Access your GIISDEC investor workspace."
        accent="emerald"
        role="investor"
        successPath="/investor/dashboard"
        otherPortal={{ label: 'GIS Workspace', to: '/gis-login' }}
      />
    </PortalShell>
  );
};

export default InvestorLogin;
